// In-memory auth token store.
//
// The access token is intentionally kept in a module-level variable instead of
// localStorage/sessionStorage. Browser storage is readable by any script running
// on the page, so a persisted token is an easy target for exfiltration via XSS.
// Keeping it in memory means it never touches disk and is cleared automatically
// when the tab/window is closed or the app is reloaded.
let authToken = null;

export const getAuthToken = () => authToken;

export const setAuthToken = (token) => {
    authToken = token;
};

export const clearAuthToken = () => {
    authToken = null;
};
